import { CSSProperties } from 'react'
import { XOR } from '../ts-utils'

export enum Action {
  add = 'add',
  delete = 'delete',
  preview = 'preview',
  clear = 'clear',
  subscribePreview = 'subscribe-preview'
}

interface ResultsOptions {
  units?: 'Meters' | 'Millimeters' | 'Feet' | 'Inches' | 'Centimeters',
}

// Generated with util/create-component.js
export interface SendResultsProps {
  results?: XOR<object,(args?: any) => Promise<object>>
  defaultAction?: Action
  defaultKey?: string
  optionsConfig?: { [index in Action]: boolean }
  geometryOptions?: ResultsOptions
  onOverlayHeightChange?: (height: number) => any
  delay?: number
}
